import './linkedin-styles.css';
import './index.css';

import React from 'react';
import ReactDOM from 'react-dom';

import { initializeHotjar } from './hotjar';
import reportWebVitals from './reportWebVitals';
import App from './views/App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

initializeHotjar(2860119, window);
